// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Router from "next/router";
import * as HeaderVm$PorterinFeature from "../vm/HeaderVm.mjs";
import * as LegalHeader$PorterinFeature from "./LegalHeader.mjs";
import * as HeaderModuleScss from "../styles/Header.module.scss";
import * as LocaleConstants$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/constants/LocaleConstants.mjs";
import * as DownloadAppCmp$PorterinFeature from "./DownloadAppCmp.mjs";
import * as HeaderLinksCmp$PorterinFeature from "./HeaderLinksCmp.mjs";
import * as HeaderMobileMenuSection$PorterinFeature from "./HeaderMobileMenuSection.mjs";

var styles = HeaderModuleScss;

function HeaderCmp(Props) {
  var data = Props.data;
  var show_download_sticky = Props.show_download_sticky;
  var match = Router.useRouter();
  var locale = match.locale;
  var match$1 = HeaderVm$PorterinFeature.getVm(data);
  var links = match$1.links;
  var company_content = match$1.company_content;
  var shouldShowLegalHeader = locale === LocaleConstants$PorterinUtils.bn_BD || locale === LocaleConstants$PorterinUtils.en_BD;
  return React.createElement("div", {
              className: styles["sticky-wrapper"]
            }, show_download_sticky ? React.createElement(DownloadAppCmp$PorterinFeature.make, {
                    data: match$1.open_app_content
                  }) : null, shouldShowLegalHeader ? React.createElement(LegalHeader$PorterinFeature.make, {
                    location_icon: company_content.location_icon,
                    company_info: company_content.company_info,
                    refund_policy_link: links.refund_policy_link,
                    terms_of_service_link: links.terms_of_service_link
                  }) : null, React.createElement("div", {
                  className: styles["header-wrapper"]
                }, React.createElement("div", {
                      className: styles["header-container"]
                    }, React.createElement(HeaderLinksCmp$PorterinFeature.make, {
                          data: data
                        })), React.createElement(HeaderMobileMenuSection$PorterinFeature.make, {
                      menu_content: match$1.menu_content
                    })));
}

var Link;

var make = HeaderCmp;

export {
  styles ,
  Link ,
  make ,
}
/* styles Not a pure module */
